var VouchersButtonView = (function (BaseView) {
    return BaseView.extend({
        el: '@vouchersButton',

        hiddenClass: 'hidden-block',

        events: {
            'click': '_display'
        },

        initialize: function () {
            _.bindAll(this, '_render', '_display');
            this.$vouchersCount = this.$('@vouchersCount');
            this.listenTo(this.collection, 'update', this._render);
        },

        _render: function () {
            var vouchersCount = this.collection.where({ 'IsApplied': false }).length;
            var display = vouchersCount > 0;
            this.$vouchersCount.text(vouchersCount);
            this.$vouchersCount.toggleClass(this.hiddenClass, !display);
        },

        _display: function (e) {
            e.preventDefault();
            this.display('checkout.vouchers');
        }
    });
})(BaseView);